export const ADDRESS_TYPES = [
    'Rue', 'Avenue', 'Boulevard', 'Chemin', 'Allée', 'Impasse',
    'Place', 'Route', 'Passage', 'Quai', 'Cours', 'Square',
];
